<script>
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import Supplier from "@/components/modals/supplier.vue";
export default {
    components: {
        DatePicker,
        Supplier
    },
    props: {
        modalTitle: String,
        locations: {
            type: Array,
            default: () => []
        },
        templates: {
            type: Array,
            default: () => []
        },
        withReading: {
            type: Boolean,
            default: false
        }
    },
    validations: {
        form: {
            accountNumber: {required},
            clientId: {required},
            dateStart: {required},
            deliveryUnitServiceMapId: {required},
        }
    },  
    data() {
        return {
            form: {
                id: 0,
                deliveryUnitServiceId: null,
                clientId: null,
                dateStart: new Date(),
                description: null,
                accountNumber: null,
                billingDay: 0,
                deliveryUnitServiceMapId: '',
                deliveryUnitServiceFeeTemplateId: '',
                meterSerialNumber: null,
                supplier: {name: null}
            },
            submitted: false,
            loadingAcc: false
        }
    },
    methods: {
        getSupplier() {
            this.$bvModal.show("supplier-modal");
        },
        dropSupplier(data){
            this.form.supplier = data;
            this.form.clientId = data.id;
        },
        updateData(data){
            this.form = cloneDeep(data);
            this.form.dateStart = new Date(data.dateStart);
            this.form.supplier = {name: data.client};
            this.submitted = false;
        },
        resetForm(){
            this.form = {
                id: 0,
                deliveryUnitServiceId: null,
                clientId: null,
                dateStart: new Date(),
                description: null,
                accountNumber: null,
                billingDay: 0,
                deliveryUnitServiceMapId: '',
                supplier: {name: null}
            }
            this.submitted = false;
            this.$v.$reset();
        },
        async getAccNo(){
            this.loadingAcc = true;
            await this.$store
                .dispatch("subscriber/GetAccountNumber")
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    console.log(res.data);
                    this.form.accountNumber = res.data;
                })
                .catch((error) => {
                    console.log(error);
                    return this.form.accountNumber = 'Error.';
                });
            this.loadingAcc = false;
        },
        addFromMap(data){
            this.form.deliveryUnitServiceMapId = data.id;
        },
        onCreate(){
            this.submitted = true;
            this.$v.form.$touch();
            if(this.$v.form.$invalid) return;
            let data = cloneDeep(this.form);
            data.dateStart = this.getDate(this.form.dateStart);
            if(data.deliveryUnitServiceFeeTemplateId != 0){
                data.deliveryUnitServiceFeeTemplate = this.templates.find(x => x.id == data.deliveryUnitServiceFeeTemplateId).templateName;
            }else{
                data.deliveryUnitServiceFeeTemplate = null;
            }
            this.$emit('submit', data);
        }
    }
}
</script>
<template>
    <b-modal
        id="subscriber-modal"
        :title="modalTitle"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <form
            @submit.prevent="onCreate"
            class="needs-validation"
            ref="fcForm"
        >
            <div class="mb-3">
                <label for="accountNumber">Account Number</label>
                <div class="d-flex">
                    <div class="form-control" :class="{'border border-danger': submitted && $v.form.accountNumber.$error}">
                        <template v-if="loadingAcc">Loading...</template>
                        <template v-else>{{ form.accountNumber || 'Error.' }}</template>
                    </div>
                    <b-button
                        variant="outline-info"
                        @click="getAccNo"
                        v-if="!loadingAcc && !form.accountNumber"
                        class="px-3"
                        title="Reload Account Number"
                    >
                        <i class="mdi mdi-refresh"></i>
                    </b-button>
                </div>
            </div>
            <div class="mb-3">
                <label for="">Client</label>
                <b-input-group>
                    <template #append>
                        <b-button @click="getSupplier" variant="outline-info" title="Search Client">
                            <i class="mdi mdi-clipboard-text-search-outline"></i>
                        </b-button>
                    </template>
                    <input
                        autocomplete="off"
                        type="text"
                        disabled
                        placeholder="Search Client..."
                        class="form-control"
                        :class="{ 'is-invalid': submitted && $v.form.clientId.$error}"
                        v-model="form.supplier.name"
                    />
                </b-input-group>
                <div
                    v-if="submitted && $v.form.clientId.$error"
                    class="invalid-feedback"
                >
                    <span v-if="!$v.form.clientId.required"
                        >This value is required.</span
                    >
                </div>
            </div>
            <div class="mb-3">
                <label for="accountNumber">Client Address</label>
                <textarea
                    v-model="form.supplier.address"
                    placeholder="Enter Address..."
                    rows="2"
                    class="form-control"
                    autocomplete="off"
                    disabled
                ></textarea>
            </div>
            <div class="mb-3">
                <label for="description">Description </label>
                <textarea
                    id="description"
                    v-model="form.description"
                    placeholder="Enter Description..."
                    class="form-control"
                    autocomplete="off"
                    rows="3"
                ></textarea>
            </div>
            <div class="mb-3">
                <label for="meterSerialNumber">{{withReading ? 'Meter Serial' : 'Serial'}} Number</label>
                <input
                    type="text"
                    id="meterSerialNumber"
                    v-model="form.meterSerialNumber"
                    :placeholder="withReading ? 'Enter Meter Serial Number...' : 'Enter Serial Number...'"
                    class="form-control"
                    autocomplete="off"
                />
            </div>
            <div class="mb-3">
                <label for="dateStarted">Date Started</label>
                <date-picker
                    id="dateStart"
                    v-model="form.dateStart"
                    :first-day-of-week="1"
                    lang="en"
                    placeholder="Enter Billing Date..."
                    :class="{ 'is-invalid': $v.form.dateStart.$error }"
                >
                </date-picker>
                <div
                    v-if="submitted && $v.form.dateStart.$error"
                    class="invalid-feedback"
                >
                    <span v-if="!$v.form.dateStart.required"
                        >This value is required.</span
                    >
                </div>
            </div>
            <div class="mb-3">
                <label for="dateStarted">Location</label>
                <select 
                    v-model="form.deliveryUnitServiceMapId" 
                    class="form-select"
                    :class="{ 'is-invalid': $v.form.deliveryUnitServiceMapId.$error }"
                >
                    <option></option>
                    <option v-for="x in locations" :key="x.id" :value="x.id">{{x.name}}</option>
                </select>
                <div
                    v-if="submitted && $v.form.dateStart.$error"
                    class="invalid-feedback"
                >
                    <span v-if="!$v.form.deliveryUnitServiceMapId.required"
                        >This value is required.</span
                    >
                </div>
            </div>
            <div class="mb-3">
                <label for="dateStarted">From Template</label>
                <select 
                    v-model="form.deliveryUnitServiceFeeTemplateId" 
                    class="form-select"
                >
                    <option value="0"></option>
                    <option v-for="x in templates" :key="x.id" :value="x.id">{{x.templateName}}</option>
                </select>
            </div>
            <div class="mb-3 d-flex align-items-center gap-1 justify-content-center">
                <span>Bills every </span> 
                <select class="form-select text-center" style="width: 90px;" v-model="form.billingDay">
                    <option>0</option>
                    <option v-for="n in 31" :key="n">{{n}}</option>
                </select>
                <span> of the month</span>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary"><i class="bx bx-save"></i>{{ form.id != 0 ? "Update" : "Save" }}</button>
                <button type="button" class="btn btn-link" @click="$bvModal.hide('subscriber-modal')">Close</button>
            </div>
        </form>
        <supplier @dropData="dropSupplier($event)"></supplier>
    </b-modal>
</template>